import { cn } from '@/lib/utils';
import React from 'react';

interface ShortDescriptionProps {
  description: string;
  variant?: 'default' | 'print';
  className?: string;
  isBig?: boolean;
}

const ShortDescription = (props: ShortDescriptionProps) => {
  const { description, className } = props;
  const isPrint = props.variant === 'print';

  return (
    <div
      className={cn(`body-text py-2`, { 'print:text-xs': isPrint }, className)}
    >
      {description}
    </div>
  );
};

export default ShortDescription;
